export interface UsuarioActividadResumenRow {
  estado?: string | null;
  vencido?: boolean | null;
  descripcion?: string | null;
  cantidad?: number;
  porcentaje?: number;
}

/** Fila agrupada por estado (sin cruce vencido). */
export function isUsuarioActividadResumenPorEstado(row: UsuarioActividadResumenRow): boolean {
  const estado = row?.estado;
  return estado != null && String(estado).trim() !== '' && row.vencido !== true;
}

/** Fila agregada solo por vencido (estado null/omitido). */
export function isUsuarioActividadResumenVencidoAgregado(row: UsuarioActividadResumenRow): boolean {
  const estado = row?.estado;
  const sinEstado = estado == null || String(estado).trim() === '';
  return sinEstado && row.vencido === true;
}

export function cantidadUsuarioActividadVencidasAgregadas(
  rows: UsuarioActividadResumenRow[],
): number {
  const row = (rows ?? []).find(isUsuarioActividadResumenVencidoAgregado);
  return Number(row?.cantidad) || 0;
}

/** Estados cuyo indicador suma vigentes + vencidas del mismo estado. */
const ESTADOS_SUMA_TODAS = new Set(['BLOQUEADO', 'EN_PROCESO', 'FINALIZADO']);

export function cantidadUsuarioActividadPorEstado(
  rows: UsuarioActividadResumenRow[],
  estado: string,
): number {
  const estadoUp = String(estado).toUpperCase();

  return (rows ?? [])
    .filter(r => {
      if (r.estado == null || String(r.estado).trim() === '') return false;
      if (String(r.estado).toUpperCase() !== estadoUp) return false;
      if (ESTADOS_SUMA_TODAS.has(estadoUp)) return true;
      return r.vencido !== true;
    })
    .reduce((sum, r) => sum + (Number(r.cantidad) || 0), 0);
}
